import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivityStreamEntityType, ActivityStreamLoadConfig } from '@coin/shared/activity-stream/util';

interface ActivityStreamDialogData {
  loadConfig: ActivityStreamLoadConfig;
  type: ActivityStreamEntityType;
}

@Component({
  selector: 'coin-activity-stream-dialog',
  templateUrl: './activity-stream-dialog.component.html',
  styleUrls: ['./activity-stream-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActivityStreamDialogComponent {
  data = inject<ActivityStreamDialogData>(MAT_DIALOG_DATA);
  private dialog = inject<MatDialogRef<ActivityStreamDialogComponent>>(MatDialogRef);

  public static openDialog(dialog: MatDialog, data: ActivityStreamDialogData): Observable<unknown> {
    return dialog
      .open<ActivityStreamDialogComponent, ActivityStreamDialogData, unknown>(ActivityStreamDialogComponent, {
        disableClose: true,
        height: '80vh',
        data
      })
      .afterClosed();
  }

  reload$ = new Subject<void>();

  constructor() {
    this.reload$.next();
  }

  public close(): void {
    this.dialog.close();
  }
}
